// Module
var code = `<div class="zoomable-picture">
  <figure class="zoomable-picture__container">
    <img class="zoomable-picture__image"
         ng-show="\$ctrl.sourceUrl"
         ng-src="{{\$ctrl.sourceUrl}}"
         alt="{{\$ctrl.description}}">
    <figcaption class="zoomable-picture__remarks"
                ng-show="\$ctrl.remarks">
      {{\$ctrl.remarks}}
    </figcaption>
  </figure>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/zoomable-picture/zoomable-picture.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;